import React, { useState } from "react";
import useRevealSequence from "../useRevealSequence";
import Celebration from "../Celebration";

/**
 * Highlight - a light runs the board.
 *
 * The plainest of the six and the one to fall back on: the yantras stay
 * where a player expects them, and a single moving highlight does the
 * work. It circles at full speed while the round finishes, then takes a
 * measured lap and a half and stops dead on the winner.
 */

/** How many tiles the light walks before it stops on the winner. */
const RUN_IN_STEPS = 5;

export default function Highlight({ tiles, winnerIndex, onFinished }) {
  const [active, setActive] = useState(0);
  const [landed, setLanded] = useState(-1);
  const count = tiles.length;

  useRevealSequence(
    async (ctx) => {
      let at = 0;

      // Round and round while the round plays out.
      while (ctx.winnerIndex() < 0) {
        at = (at + 1) % count;
        setActive(at);
        await ctx.sleep(70);
      }
      const target = ctx.winnerIndex();

      // Always the same short run in, wherever the winner sits: step back
      // a fixed distance from it and walk that.
      const steps = RUN_IN_STEPS;
      at = (target - steps + count * 2) % count;
      for (let n = 1; n <= steps; n++) {
        at = (at + 1) % count;
        setActive(at);
        const t = n / steps;
        await ctx.sleep(28 + 150 * t * t);
      }

      setLanded(target);
      await ctx.sleep(1200);
      onFinished();
    },
    winnerIndex,
    [count],
  );

  const winner = landed >= 0 ? tiles[landed] : null;

  return (
    <div className="rv-hl">
      <div className="rv-hl-grid" data-count={count}>
        {tiles.map((tile, i) => (
          <div
            key={tile.id}
            className={[
              "rv-card",
              i === active && landed < 0 ? "rv-card--active" : "",
              i === landed ? "rv-card--winner" : "",
              landed >= 0 && i !== landed ? "rv-card--dim" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <img src={tile.img} alt={tile.name || ""} />
            <span>{tile.name}</span>
          </div>
        ))}
      </div>

      {winner ? <Celebration tile={winner} seed={landed} /> : null}
    </div>
  );
}
